export let env = "";

export const setEnv = (configs) => {
	env = configs;
};
export const getEnv = () => {
	return env;
};
